import React, { useState } from 'react';
import { Modal, Typography, Tag, Spin } from 'antd';
import { getWorkWiseAuthToken } from '../../utils/helper';
import { useParams } from 'react-router-dom';
import './style.css';

const { Title, Text } = Typography;

const PreviewVersionModal = ({ version = 'server', isvisible, setIsVisible }) => {
  const { id } = useParams();
  const baseUrl = `https://grid.workw.com/milegrid/${id}/`;
  const token = getWorkWiseAuthToken() || "";
  const previewUrl = `${baseUrl}?token=${token}&readOnly=true&versionType=${version}`;

  const [loading, setLoading] = useState(true);

  const versionColor = version === 'server' ? 'blue' : 'green';
  const versionLabel = version === 'server' ? 'Server Version' : 'Offline Version';

  return (
    <Modal
      visible={isvisible}
      onCancel={() => setIsVisible(false)}
      footer={null}
      width={850}
      centered
      bodyStyle={{ padding: '20px' }}
      title={
        <div className="preview-modal-header">
          <Title level={4} className="preview-modal-title">
            {versionLabel} Preview
          </Title>
          <Tag color={versionColor}>{versionLabel}</Tag>
        </div>
      }
    >
      <div className="preview-description">
        <Text type="secondary">
          You are previewing the <b>{versionLabel.toLowerCase()}</b> of this document.  
          This view is read-only and meant for comparison purposes.
        </Text>
      </div>

      <div className="preview-iframe-wrapper">
        {loading && (
          <div className="preview-loading-overlay">
            <Spin size="large" tip="Loading preview..." />
          </div>
        )}
        <iframe
          src={previewUrl}
          title={`${version} version preview`}
          className="preview-iframe"
          onLoad={() => setLoading(false)}
        />
      </div>
    </Modal>
  );
};

export default PreviewVersionModal;